

import { Component } from '@angular/core';

@Component({
  selector: 'icon-voice',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path d="M2 10.5V13.5M6 6.5V17.5M10 3.5V21.5M14 8.5V15.5M18 5.5V18.5M22 10.5V13.5" stroke="#F8F9FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  styles: `
    svg{
        cursor: pointer;
    }
  `
})

export class VoiceIconComponent {}
